<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import PageGrid from '../components/pageGrid.svelte';
	import type { SbImage, SbImageFormat } from '../types';
	import Image from '../components/image.svelte';

	interface Props {
		content: ISbStoryData['content'] & {
			file?: SbImage;
			format: Extract<SbImageFormat, '1/1' | '4/3' | '16/9'>;
		};
	}

	let { content }: Props = $props();
</script>

<PageGrid class="mb-8 mt-10">
	<div
		class="col-span-full lg:col-start-4 lg:col-end-10 aspect-{content.format} group overflow-hidden rounded-2xl"
		use:editable={content}
	>
		{#if content.file?.filename}
			<Image
				src={content.file.filename}
				class="h-full w-full transform-gpu object-cover object-center transition-transform duration-600 group-hover:scale-105"
				alt={content.file.alt ?? ''}
				title={content.file.title ?? ''}
				width={780}
				sizes={{ 1024: { width: 1354 } }}
			/>
		{/if}
	</div>
</PageGrid>
